import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession, getFileServer } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import userService from "../services/userService";
import { Checkbox } from "primereact/checkbox";
import { Paginator } from "primereact/paginator";
import saleOrderService from "../services/saleOrderService";
import { Timeline } from "primereact/timeline";

export default class Orders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            first: 0,
            rows: 10,
            totalRecords: 0,
            saleOrders: [],
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            var response = await saleOrderService.getSaleOrders(0, 10);

            this.setState({
                saleOrders: response.data.content,
                totalRecords: response.data.totalElements,
                first: 0,
                rows: response.data.size,
            });

            window.addEventListener("resize", this.handleResize);
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    formatarTelefone(telefone) {
        telefone = telefone.replace(/\D/g, "");

        // Verifica se tem DDD
        if (telefone.length <= 10) {
            // Formato: (XX) XXXX-XXXX
            return telefone.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        } else {
            // Formato: (XX) XXXXX-XXXX
            return telefone.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
        }
    }

    onPageChange = async (event) => {
        await showProcess();

        try {
            this.setState({ first: event.first, rows: event.rows });

            var response = await saleOrderService.getSaleOrders(event.first, event.rows);

            this.setState({
                saleOrders: response.data.content,
                totalRecords: response.data.totalElements,
                first: event.first,
                rows: event.rows,
            });
        } catch (e) {
            alert(e);
        }

        hideProcess();
    };

    getEvents = (e) => {
        var events = [
            {
                status: "PEDIDO REALIZADO",
                date: e.createdAt,
                icon: "pi pi-shopping-cart",
            },
        ];

        if (e.status === "AWAITING_PAYMENT") {
            events.push({
                status: "PENDENTE PAGAMENTO",
                date: e.createdAt,
                icon: "pi pi-shopping-cart",
            });
        } else {
            events.push({
                status: "PEDIDO PAGO",
                date: e.createdAt,
                icon: "pi pi-shopping-cart",
            });
        }

        if (e.status === "ACTIVATED") {
            events.push({
                status: "PEDIDO APROVADO",
                date: e.lines[0]?.returnDate,
                icon: "pi pi-shopping-cart",
            });
        }

        if (e.status === "DENIED") {
            events.push({
                status: "PEDIDO NEGADO",
                date: e.lines[0]?.returnDate,
                icon: "pi pi-shopping-cart",
            });
        }

        if (e.emailStatus === "SENT") {
            events.push({
                status: "EMAIL ENVIADO",
                date: e.lines[0]?.returnDate,
                icon: "pi pi-shopping-cart",
            });
        }

        return events;
    };

    render() {
        if (UserSession === null || UserSession === undefined || UserSession === "") {
            window.location.href = "/login";
            return;
        }
        return (
            <div
                style={{
                    padding: this.state.windowWidth < 768 ? "10px" : "20px",
                    overflowX: "hidden",
                    boxSizing: "border-box",
                    width: "100%",
                }}
            >

                <div
                    style={{
                        borderBottom: "2px solid #E9E5F2",
                        padding: this.state.windowWidth < 768 ? "15px 0px" : "25px 0px",
                        marginBottom: "50px",
                    }}
                >
                    <label
                        style={{
                            fontSize: "22px",
                            color: "#110235",
                            fontWeight: "500",
                        }}
                    >
                        Meus Pedidos
                    </label>
                </div>

                <div>
                    {this.state.saleOrders.map((e) => (
                        <table
                            key={e.id}
                            style={{
                                marginBottom: "50px",
                                width: "100%",
                                tableLayout: "fixed",
                                wordWrap: "break-word",
                                borderCollapse: "collapse",
                            }}
                        >
                            <tr
                                style={{
                                    display: this.state.windowWidth < 768 ? "block" : "table-row",
                                }}
                            >
                                <td
                                    style={{
                                        verticalAlign: "top",
                                        width: this.state.windowWidth < 768 ? "100%" : "50%",
                                        display: this.state.windowWidth < 768 ? "block" : "table-cell",
                                    }}
                                >
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td colSpan={2} style={{ padding: "4px 0px" }}>
                                                <a href={"/saleorder/" + e.id} style={{ textDecoration: "none" }}>
                                                    <label
                                                        style={{
                                                            fontSize: "22px",
                                                            color: "#100034",
                                                            textDecoration: "none",
                                                            fontWeight: "bold",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Pedido {e.id}
                                                    </label>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "4px 20px 4px 0px" }}>
                                                <label
                                                    style={{
                                                        fontSize:"16px",
                                                        color: "#4A4A4A",
                                                    }}
                                                >
                                                    Realizado em:{" "}
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize:"16px",
                                                        color: "#4A4A4A",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {new Date(e.createdAt).toLocaleDateString()}
                                                </label>
                                            </td>
                                            <td style={{ padding: "4px 20px 4px 0px" }}>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        color: "#4A4A4A",
                                                    }}
                                                >
                                                    Ítens do pedido:{" "}
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        color: "#4A4A4A",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {e.lines instanceof Array ? e.lines.length : 0}
                                                </label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "4px 20px 4px 0px" }}>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        color: "#4A4A4A",
                                                    }}
                                                >
                                                    Total:{" "}
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        color: "#4A4A4A",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    R$
                                                    {e.amount.toLocaleString("pt-BR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                </label>
                                            </td>
                                            <td style={{ padding: "4px 20px 4px 0px" }}>
                                                <label
                                                    style={{
                                                        fontSize: "16px",   
                                                        color: "#4A4A4A",
                                                    }}
                                                >
                                                    Forma de Pagamento:{" "}
                                                </label>
                                                <label
                                                    style={{
                                                        fontSize: "16px",
                                                        color: "#4A4A4A",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {e.typePayment}
                                                </label>
                                            </td>
                                        </tr>
                                    </table>

                                <table
                                        style={{
                                            marginTop: "40px",
                                            width: "100%",
                                            textAlign: "center",
                                            
                                        }}
                                    >
                                        <tr>
                                            <td>
                                                <img
                                                    src={`${this.state.fileServer}/cards/${e.lines instanceof Array && e.lines.length > 0 ? e.lines[0].product.id : "0"}.png`}
                                                    alt="Gamers Fans"
                                                    style={{
                                                        width:
                                                            this.state.windowWidth < 768
                                                                ? "100%"
                                                                : "308px",
                                                        height:
                                                            this.state.windowWidth < 768
                                                                ? "auto"
                                                                : "180px",
                                                        maxWidth: "100%",
                                                        borderRadius: "10px",
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </td>

                                <td
                                    style={{
                                        verticalAlign: "top",
                                        display: this.state.windowWidth < 768 ? "block" : "table-cell",
                                        width: this.state.windowWidth < 768 ? "100%" : "auto",
                                        marginTop: this.state.windowWidth < 768 ? "20px" : "0px",
                                        borderLeft: "2px solid #E9E5F2",
                                        paddingLeft: this.state.windowWidth < 768 ? "0px" : "40px",
                                    }}
                                >
                                    <label
                                        style={{
                                            fontSize: this.state.windowWidth < 768 ? "18px" : "22px",
                                            color: "#4A4A4A",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Status do Pedido:
                                    </label>
                                    <div style={{ marginTop: "20px" }}>
                                        <Timeline
                                            value={this.getEvents(e)}
                                            content={(item) => (
                                                <div>
                                                    <label
                                                        style={{
                                                            fontSize:"16px",
                                                            color: "#868686",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {item.status}
                                                    </label>
                                                    <br />
                                                    <label
                                                        style={{
                                                            fontSize: "14px",
                                                            color: "#868686",
                                                        }}
                                                    >
                                                        {new Date(item.date).toLocaleDateString()}{" "}
                                                        {new Date(item.date).toLocaleTimeString()}
                                                    </label>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </td>
                                <td />
                            </tr>
                        </table>
                    ))}
                </div>

                <Paginator
                    first={this.state.first}
                    rows={this.state.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={this.onPageChange}
                />
            </div>
        );
    }
}
